import React, { PropsWithChildren } from 'react';
import { ThemeProvider, DefaultTheme } from 'styled-components';
import { ModalProvider } from 'styled-react-modal';
import merge from 'lodash/merge';

import baseTheme from 'theme';
import { ModalBackground } from 'components/modal/styles';
import { Head } from 'components/head/Head';

type MaybeString = string | false | undefined;

type LocalHeadProps = Partial<{
    title: MaybeString;
    description: MaybeString;
    font: MaybeString;
    resetCss: MaybeString;
    fullHeightCss: MaybeString;
    customCss: MaybeString;
}>;

export interface AppProviderProps {
    theme?: Partial<DefaultTheme> | Record<string, unknown>;
    head?: LocalHeadProps;
    enableGlobalStyles?: boolean;
}

export const AppProvider: React.FC<PropsWithChildren<AppProviderProps>> = ({
    theme,
    head,
    enableGlobalStyles = true,
    children,
}) => {
    const appTheme = merge({}, baseTheme, theme) as DefaultTheme;

    return (
        <div className="theme-provider">
            <ThemeProvider theme={appTheme}>
                {enableGlobalStyles ? <Head {...(head || {})} /> : null}
                <ModalProvider backgroundComponent={ModalBackground}>{children}</ModalProvider>
            </ThemeProvider>
        </div>
    );
};

export default AppProvider;
